export default __webpack_public_path__ + "static/media/ball.0d2c68e3.jpeg";